<script>

  import { Line } from 'vue-chartjs'
  import axios from 'axios'
  import Utils from '@/utils.js'
  import { EventBus } from '@/global-event-bus.js'
  import { EVENT_ANALYTIC_DATE_RANGE, DATE_FROM, DATE_TO } from '@/event-constants.js'

  export default {
    name: 'LineChart',

    extends: Line,

    data() {
      return {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                type: 'time',
                time: {
                  format: 'YYYY-MM-DD',
                  tooltipFormat: 'll',
                  unit: 'day'
                },
                display: true,
                scaleLabel: {
                  display: true
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  callback: function(value) {
                    if (value % 1 === 0) {
                      return value
                    }
                  }
                }
              }
            ]
          }
        }
      }
    },

    props: {
      chartdata: {
        type: Object,
        default: null
      }
    },

    mounted() {
      this.renderChart(this.chartdata, this.options)
    },

    created() {
      EventBus.$on(EVENT_ANALYTIC_DATE_RANGE, this.fetchData)
    },

    beforeDestroy() {
      EventBus.$off(EVENT_ANALYTIC_DATE_RANGE, this.fetchData)
    },

    methods: {},

    computed: {},

    watch: {
      chartdata() {
        this.renderChart(this.chartdata, this.options)
      }
    }
  }

</script>

<style scoped></style>
